<p-panel [header]="'Yarn_Details_Composition_Title' | translateWF: 'Composition'">
  <p-card data-variant="flat">
    <!-- Dynamic color bar -->
    <div class="sample-color">
      <div
        *ngFor="let comp of fabricComposition"
        class="sample-color__item"
        [style.width.%]="comp.percentage"
        [style.background-color]="getCompositionColor(comp.compositionCode)"
      ></div>
    </div>

    <p-divider />

    <!-- Dynamic composition info -->
    <div class="info-compostion">
      <div class="info-composition__item" *ngFor="let comp of fabricComposition">
        <div>
          <span [style.background-color]="getCompositionColor(comp.compositionCode)"></span>
          <p>
            <b>{{ getCompositionName(comp.compositionCode) }}</b>
          </p>
        </div>
        <p>{{ comp.percentage }}%</p>
      </div>
    </div>
  </p-card>
</p-panel>
